import React, { FC, useState, useEffect, useContext } from 'react'
import platform from 'platform'
import { notify } from 'react-notify-toast'
import moment from 'moment'
import { isMobile } from 'react-device-detect'

import {
  getUserData,
  getTrainingDays,
  unSubscribeNewsletter,
  subscribeToNewsletter,
} from '../../../../Api/backendApi'

import GenericTextSpan from '../../../../GenericComponents/GenericTextSpan'
import GenericRow from '../../../../GenericComponents/GenericRow'
import GenericButton from '../../../../GenericComponents/GenericButton'
import GenericCloseButton from '../../../../GenericComponents/GenericCloseButton'

import {
  SingleSettingModalBox,
  UserDataContainer,
} from '../../style/UserProfileStyle'

interface RemoveFromNewsletterInterface {
  closeModal: Function
}

const RemoveFromNewsletter: FC<RemoveFromNewsletterInterface> = ({
  closeModal,
}) => {
  const [userData, setUserData] = useState(Object)

  const getUser = async () => {
    const result: any = await getUserData()

    setUserData(result)
  }

  useEffect(() => {
    ;(async () => {
      getUser()
    })()
  }, [])

  const handleSubUnsubNewsletterButton = async () => {
    if (userData.is_newsletter_subscriber) {
      await unSubscribeNewsletter()
      await getUser()
    } else {
      await subscribeToNewsletter()
      await getUser()
    }
  }

  return (
    <SingleSettingModalBox>
      <GenericCloseButton onClick={closeModal} />
      <GenericRow margin={'0% 0 3% 0'}>
        <GenericTextSpan fSize={'2rem'} fWeight={'bold'}>
          {userData && userData.is_newsletter_subscriber
            ? 'Usuń z newslettera'
            : 'Zapisz do newslettera'}
        </GenericTextSpan>
      </GenericRow>
      <GenericRow>
        <GenericTextSpan
          fSize={isMobile ? '1.3rem' : '1rem'}
          width={isMobile ? '90%' : '60%'}
        >
          Czy jesteś pewna, że chcesz{' '}
          {userData && userData.is_newsletter_subscriber
            ? 'usunąć newsletter?'
            : 'zapisać się do newslettera?'}
        </GenericTextSpan>
      </GenericRow>

      <GenericButton
        width={isMobile ? '90%' : '50%'}
        className="standard"
        margin={'4% auto'}
        justify={'center'}
        onClick={handleSubUnsubNewsletterButton}
      >
        {userData && userData.is_newsletter_subscriber
          ? 'Usuń z newslettera'
          : 'Zapisz do newslettera'}
      </GenericButton>
    </SingleSettingModalBox>
  )
}

export default RemoveFromNewsletter
